import { ConfigProvider } from 'antd'
import ru_RU from 'antd/locale/ru_RU'
import { Suspense, useEffect } from 'react'
import { initAuthData } from '../entities/User'
import { classNames } from '../shared/lib/classNames/classNames'
import { useAppDispatch } from '../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { useSiteTheme } from '../shared/lib/hooks/useSiteTheme/useSiteTheme'
import { PageLoader } from '../shared/ui/PageLoader/PageLoader'
import './App.css'
import { AppRouter } from './providers/router'
import { Theme, useTheme } from './providers/ThemeProvider'

export const App = () => {
    const { theme } = useTheme()
    const dispatch = useAppDispatch()
    useSiteTheme()

    useEffect(() => {
        dispatch(initAuthData())
    }, [dispatch])

    return (
        <div className={classNames('app', {}, [theme || Theme.LIGHT])}>
            <ConfigProvider
                locale={ru_RU}
                theme={{
                    token: {
                        fontFamily: 'Giltroy'
                    },
                    components: {
                        Table: {
                            headerBorderRadius: 20,
                            headerBg: '#f4f7fa'
                        }
                    }
                }}
            >
                <Suspense fallback={<PageLoader />}>
                    <AppRouter />
                </Suspense>
            </ConfigProvider>
        </div>
    )
}
